export const jobsMarkerStyles = {
  cursor: 'pointer',
  position: 'absolute',
  transform: 'translate(-50%, -50%) scale(1)',
  '&:hover': {
    transform: 'translate(-50%, -50%) scale(1.1)',
    transition: 'transform 0.08s linear',
  },
};
